// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { iota as _iota } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the iota chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 8822
 * Chain Name: IOTA EVM
 * Default Block Explorer: https://explorer.evm.iota.org
 * Default RPC URL: https://json-rpc.evm.iotaledger.net
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { iota } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: iota,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const iota = createCommon({
	..._iota,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
